<template>
  <v-layout row wrap>
    <v-flex xs12><v-divider /></v-flex>
    <v-flex xs12>
      <div class="text-xs-center pt-4">
        <div class="headline">Experience</div>
      </div>

      <v-tabs-items v-model="slide">
        <v-tab-item
          v-for="(experience, i) in sortedExperiences"
          :key="`experience-${i}`"
          @click="nextSlide"
        >
          <v-card flat class>
            <v-layout row wrap align-center fill-height>
              <v-flex xs12 md4 class="text-xs-center pt-3">
                <v-avatar :size="$vuetify.breakpoint.mdAndUp ? 150 : 100">
                  <img
                    v-if="experience.organization"
                    :src="
                      experience.organization.logo ||
                        '/img/missing/logos/organizations/original.png'
                    "
                  />
                </v-avatar>
                <div
                  v-if="experience.startsAt || experience.endsAt"
                  :class="themes.client.light.mutedText"
                  class="pt-3"
                >
                  <span v-if="experience.startsAt && experience.startsAt !== experience.endsAt">
                    {{ new Date(experience.startsAt) | date('MMM yyy') }} -&nbsp;
                  </span>
                  <span v-if="experience.endsAt">
                    {{ new Date(experience.endsAt) | date('MMM yyy') }}
                  </span>
                  <span v-else>Present</span>
                </div>
                <div
                  v-if="experience.startsAt !== experience.endsAt"
                  :class="themes.client.light.mutedText"
                  class="caption"
                >
                  <span v-if="experience.endsAt">
                    {{ experience.startsAt | inWords({ to: experience.endsAt }) }}
                  </span>
                  <span v-else> {{ new Date(experience.startsAt) | inWords }} </span>
                </div>
              </v-flex>
              <v-flex xs12 md8>
                <div class="text-xs-center text-md-left py-4">
                  <div class="title">{{ experience.position }}</div>
                  <div v-if="experience.organization.name">
                    {{ experience.type }} at {{ experience.organization.name }}
                  </div>
                </div>

                <v-card-text
                  v-if="experience.responsibilities"
                  class="pt-0 text-xs-center text-md-left"
                >
                  <div :class="themes.client.light.mutedText" class="text-xs-center text-md-left">
                    Responsibilities
                  </div>
                  <div
                    v-for="(responsibility, i) in experience.responsibilities"
                    :key="i"
                    class="pt-2"
                  >
                    <v-icon left :color="themes.client.light.muted">mdi-clipboard-check</v-icon>
                    {{ responsibility }}
                  </div>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-tabs v-model="slide" slider-color="transparent" centered>
        <v-tab v-for="(experience, i) in sortedExperiences" :key="`experience-${i}`">
          <v-icon small>mdi-briefcase</v-icon>
        </v-tab>
      </v-tabs>
    </v-flex>
  </v-layout>
</template>

<script>
// Components

// Vue Component
export default {
  props: { profile: { type: Object, required: true }, experiences: Array },

  data() {
    return {
      slide: 0,
    }
  },

  computed: {
    sortedExperiences() {
      if (!this.experiences || !this.experiences[0]) return []

      const sortedExperiences = JSON.parse(JSON.stringify(this.experiences))
      return sortedExperiences.sort(({ endsAt: a }, { endsAt: b }) => {
        if (!a) return -1
        if (!b) return 1
        if (new Date(a) > new Date(b)) return -1
        if (new Date(a) < new Date(b)) return 1
        return 0
      })
    },
  },

  methods: {
    nextSlide() {
      if (this.slide + 1 < this.experiences.length) return this.slide++
      return (this.slide = 0)
    },
  },
}
</script>
